<template>
  <div
    ref="wedgeContainer" class="wedge container-fluid p-0" :style="{'--before-bg-color-var': `var(${beforeBgColor})`,'--after-bg-color-var': `var(${afterBgColor})`}">
    <div :class="['wedge-photo', className]">
      <!-- Dynamically set the image source -->
      <img :src="resolvedImgUrl" ref="parallaxImage" alt="Logo" />
    </div>
  </div>
</template>

<script>
// Webpack method: Use `require.context()` to dynamically load images
const images = require.context('@/assets/images/', false, /\.(png|jpe?g|svg)$/);

export default {
  name: "BlockWedge",
  props: {
    className: String,
    imgUrl: String, // Pass only the filename (e.g., "reviewing-data.jpg")
    beforeBgColor: String,
    afterBgColor: String,
  },
  computed: {
    // Resolve image path dynamically using Webpack's `require.context`
    resolvedImgUrl() {
      return images(`./${this.imgUrl}`) || "";
    }
  },
  
  data() {
    return {
      initialTransform: 0, // Store initial transformY value
    };
  },
  
  methods: {
    handleParallax() {
      const image = this.$refs.parallaxImage;
      const container = this.$refs.wedgeContainer;
      if (!image || !container) return;
  
      const rect = container.getBoundingClientRect();
      const windowHeight = window.innerHeight;
  
      // Adjustments based on screen ratio
      const screenRatio = window.innerWidth / window.innerHeight;
      const parallaxStart = screenRatio < 1 ? 0.6 : 0.5; // Start lower on narrower screens
      const speed = screenRatio < 1 ? 35 : 25; // Increase effect on narrower screens
  
      // Use the stored initial transform as the base offset
      const viewportTrigger = windowHeight * parallaxStart;
      if (rect.top < viewportTrigger && rect.bottom > 0) {
        const progress = (viewportTrigger - rect.top) / viewportTrigger;
        
        // Apply parallax effect using the initialTransform as the starting point
        image.style.transform = `translateY(${this.initialTransform + progress * speed}px)`;
      }
    },
  },
  
  mounted() {
    const image = this.$refs.parallaxImage;
    if (image) {
      // Set the initial transformY value so there's no jump
      this.initialTransform = -image.clientHeight * 0.1;
      image.style.transform = `translateY(${this.initialTransform}px)`;
    }
  
    // Apply parallax on load
    this.handleParallax();
  
    // Add event listeners for scrolling and resizing
    window.addEventListener("scroll", this.handleParallax);
    window.addEventListener("resize", this.handleParallax);
  },
  
  beforeUnmount() {
    // Cleanup event listeners
    window.removeEventListener("scroll", this.handleParallax);
    window.removeEventListener("resize", this.handleParallax);
  },
  
};
</script>